import React, { forwardRef } from 'react';
export const Icon = forwardRef(({ src, style, alt = '', onClick, className = '' }, ref) => {
    return (React.createElement("img", { src: src, ref: ref, alt: alt, onClick: onClick, style: style, className: `cb-icon ${onClick ? 'cb-pointer' : ''} ${className}` }));
});
